"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMobileTableData = void 0;
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var useGetStatus_1 = require("./useGetStatus");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useMobileTableData = function (data) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var tPeriods = (0, next_intl_1.useTranslations)('lossPeriods');
    var getStatus = (0, useGetStatus_1.useGetStatus)();
    var router = (0, navigation_1.useRouter)();
    // const { deleteBetLimit, isSubmitting: delBetLimitsLoading } =
    //   useDeleteBetLimits({
    //     successAction: router.refresh,
    //   })
    // const { deleteDepositLimit, isSubmitting: delDepLimitsLoading } =
    //   useDeleteDepositLimits({
    //     successAction: router.refresh,
    //   })
    // const { deleteLossLimit, isSubmitting: delLossLimitsLoading } =
    //   useDeleteLossLimits({
    //     successAction: router.refresh,
    //   })
    // const deleteLimitHandler = useCallback(
    //   ({ type, id }: { type: string; id: string }) => {
    //     type === 'deposit'
    //       ? deleteDepositLimit({ id })
    //       : type === 'loss'
    //       ? deleteLossLimit({ id })
    //       : deleteBetLimit({ id })
    //   },
    //   [deleteBetLimit, deleteDepositLimit, deleteLossLimit],
    // )
    return (0, react_1.useMemo)(function () {
        return data.map(function (item) {
            var id = item.id, expire_at = item.expire_at, status = item.status, currency = item.currency, amount = item.amount, period = item.period, type = item.type;
            return {
                expireAt: expire_at && (0, date_fns_1.format)(new Date(expire_at), 'HH:mm, dd-LL-yy'),
                currency: currency,
                status: (react_1.default.createElement(ui_components_1.StatusText, { status: getStatus(status) }, t("".concat(status)))),
                amount: amount,
                typeOfLimit: t(type),
                period: period ? tPeriods(period) : '-',
                actions: (react_1.default.createElement("div", { className: styles_module_scss_1.default.actionWrapper })),
            };
        });
    }, [
        tPeriods,
        getStatus,
        // deleteLimitHandler,
        t,
        // delDepLimitsLoading,
        // delLossLimitsLoading,
        // delBetLimitsLoading,
        data,
    ]);
};
exports.useMobileTableData = useMobileTableData;
